// components/letsTalkSection.jsx
import React from 'react';
import './styles/letsTalkSection.css';

const LetsTalkSection = () => {
  return (
    <section id="contact" className="lets-talk-section">
      <div className="lets-talk-container">
        <div className="lets-talk-content">
          <h2 className="lets-talk-title">Let's Talk</h2>
          <p className="lets-talk-subtitle">
            Ready to transform your digital presence? Let's create something extraordinary together.
          </p>
          <div className="lets-talk-buttons">
            <a href="mailto:info@mangold.ai" className="talk-button talk-button-primary">
              Start a Project
            </a>
            <a href="mailto:info@mangold.ai" className="talk-button talk-button-secondary">
              Schedule a Call
            </a>
          </div>
        </div>
        
        <div className="lets-talk-info">
          <div className="info-item">
            <div className="info-label">Email</div>
            <a href="mailto:info@mangold.ai" className="info-value">info@mangold.ai</a>
          </div>
          <div className="info-item">
            <div className="info-label">Location</div>
            <div className="info-value">Dover, DE, USA</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LetsTalkSection;